
import { getAnioDefault } from '../utils/getAnioDefault';

export class ArcFiltros {
    tipoClasificador: string = "";
    tipoValor: string = "";
    idTipoValor: string = "";
    idVariable: string = "";
    codigo: string = "";
    indicador: string = "";
    sector: string = "";
    entidad: string = "";
    anio: string = getAnioDefault();
    desagregacionPoblacional: string = "";
    codigoDivipolaDpto: string = "";
    codigoDivipolaMpio: string = "";
    codigoDivipolaPdetRegion: string = "";
    codigoDivipolaPdetMunicipio: string = "";
    unidadMedida: string = "";
    esPDET: string = "";
    periodo: string = "";
    regrescarFiltros: number = 0;
    internos: string = "";
    primerainfancia: string = "";
    sentenciaT302: string = "";
    tiposClasificadores: string = "";
    anios: string = "";
    //originales
    originalAnio: string = "";
    originalCodigoDivipolaDpto: string = "";
    originalCodigoDivipolaMpio: string = "";
    originalCodigoDivipolaPdetRegion: string = "";
    originalCodigoDivipolaPdetMunicipio: string = "";
    originalPeriodo: string = "";
    originalEsPDET: string = "";
    originalInternos: string = "";
    IsFilter:boolean=false;
}

export const DEFAULT_FILTER: ArcFiltros = {    
    tipoClasificador: "",
    tipoValor: "",
    idTipoValor: "",
    idVariable: "",
    codigo: "",
    indicador: "",
    sector: "",
    entidad: "",
    anio: getAnioDefault(),    
    desagregacionPoblacional: "",
    codigoDivipolaDpto: "",
    codigoDivipolaMpio: "",
    codigoDivipolaPdetRegion: "",
    codigoDivipolaPdetMunicipio: "",
    unidadMedida: "",    
    esPDET: "",
    periodo: "",
    regrescarFiltros: 0,
    internos : "",
    primerainfancia: "",
    sentenciaT302: "",
    tiposClasificadores: "",
    anios: "",
    //originales
    originalAnio: "",
    originalCodigoDivipolaDpto: "",
    originalCodigoDivipolaMpio: "",
    originalCodigoDivipolaPdetRegion: "",
    originalCodigoDivipolaPdetMunicipio: "",
    originalPeriodo: "",
    originalEsPDET: "",
    originalInternos: "",
    IsFilter:false
};